import { Browser } from '@capacitor/browser';
import { IonCol, IonContent, IonGrid, IonPage, IonRow } from '@ionic/react';
import React from 'react';
import { useIntl } from 'react-intl';
import { GenericMessages } from 'src/intl/GenericMessages';
import spincatImage from '../assets/images/sa-spincat-downhole-tools.png';
import trainingImage from '../assets/images/sa-training.png';
import warthogImage from '../assets/images/sa-warthog-sewer.png';
import waterblastImage from '../assets/images/sa-waterblast-tools.png';
import MobileHeader from '../components/reusable-components/MobileHeader';
import { englishOnlyIntl, useGA4 } from '../utils/ga4';

const imageLinks = [
  {
    image: waterblastImage,
    url: 'https://www.stoneagetools.com/Catalog/products',
  },
  {
    image: warthogImage,
    url: 'https://www.warthog-nozzles.com',
  },
  {
    image: spincatImage,
    url: 'https://www.stoneagetools.com/Catalog/products/application/downhole-cleaning',
  },
  {
    image: trainingImage,
    url: 'https://www.stoneagetools.com/training',
  },
];

const openBrowser = async (url: string) => {
  await Browser.open({ url, presentationStyle: 'popover', windowName: '_blank' });
};

export const StoneAgePage: React.FC = () => {
  document.title = englishOnlyIntl.formatMessage(GenericMessages.stoneAge);
  useGA4();

  const intl = useIntl();

  return (
    <IonPage>
      <MobileHeader title={intl.formatMessage(GenericMessages.stoneAge)} />
      <IonContent>
        <IonGrid>
          <IonRow>
            {imageLinks.map(link => (
              <IonCol key={link.url} size="12" sizeLg="6">
                <img src={link.image} alt="" onClick={() => openBrowser(link.url)} style={{ cursor: 'pointer' }} />
              </IonCol>
            ))}
          </IonRow>
        </IonGrid>
        {/* Removing until copy provided */}
        {/* <NewsCard /> */}
      </IonContent>
    </IonPage>
  );
};

export default StoneAgePage;
